<template>
  <div class="row align-center">
    <div class="col-6">
      <div class="text-barlow-condensed title">{{ $t(title) }}</div>
      <div class="text-barlow-condensed subtitle text-primary" v-if="subTitle">
        {{ subTitle }}
      </div>
      <div class="text-barlow-condensed subtitle-2">
        {{ body }}
      </div>
    </div>
    <div class="col-6">
      <img :src="img" alt="" class="w-200" />
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderView",
  props: ["title", "subTitle", "body", "img"],
};
</script>
